var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8235 5.96334L11.6294 4.54044L12.0062 1.03621L10.2291 0L7.41176 2.08222L4.59441 0L2.81647 1.03621L3.19413 4.54044L0 5.96334V8.03666L3.19413 9.45955L2.81647 12.9638L4.59441 14L7.41176 11.9178L10.2291 14L12.0062 12.9638L11.6294 9.45955L14.8235 8.03666V5.96334ZM7.41088 8.87151L5.55793 7.00044L7.41088 5.12938L9.26382 7.00044L7.41088 8.87151Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.f93d2bf6ffa49db55ee348dd98ecdd0d.svg";
export { ForwardRef as ReactComponent };